import { getItem, getSessionItem } from 'utils/local-storage';
import { DISCOUNT_CODE, URL_QUERY_STRING } from 'utils/storage-keys';
import { message } from 'antd';
import env from 'utils/env';
import GlobalStore from 'stores/globalStore';
import { getCurrentSubscription } from 'utils/helpers';

type UTMSource = {
  utm_source?: string;
  utm_content?: string;
  utm_term?: string;
  utm_medium?: string;
  utm_campaign?: string;
  placement?: string;
  lead_source?: string;
};

type UpgradeOption = {
  site_code: string;
  session_token: string;
  unused_money: number;
  is_upgrade: boolean;
  user_id: string;
};

const useSaveLead = () => {
  const { entitlements } = GlobalStore.useContainer();

  const getUTM = () => {
    const href = getSessionItem(URL_QUERY_STRING);
    const url = new URLSearchParams(href ? href : '');
    const utmObject = Object.fromEntries(url);
    const utmSource: UTMSource = {
      utm_source: utmObject['utm_source'] || 'SEO',
      utm_content: utmObject['utm_content'] || '',
      utm_term: utmObject['utm_term'] || '',
      utm_medium: utmObject['utm_medium'] || '',
      utm_campaign: utmObject['utm_campaign'] || '',
      placement: utmObject['placement'] || '',
      lead_source: utmObject['lead_source'] || 'subscribes'
    };
    return utmSource;
  };

  const isPhoneValid = (number: string) => {
    return /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/.test(number);
  };

  const saveLead = (
    profileObject: any,
    membershipString = 'lifetime_membership',
    tracking?: UTMSource,
    upgradeOption?: UpgradeOption
  ) => {
    let discount_code = 'VNTEL';
    if (!entitlements) {
      return;
    }
    const currentPackages = getCurrentSubscription(entitlements);
    discount_code =
      currentPackages === 'one_year_credit'
        ? 'VNUPSALE'
        : currentPackages === 'three_months_credit'
        ? 'VNUP3M'
        : currentPackages === 'six_months_credit'
        ? 'VNUP6M'
        : currentPackages === 'two_years_credit'
        ? 'VNUP2Y'
        : 'VNTEL';

    const utm = getUTM();
    const config = env();

    const formdata: any = {
      name: profileObject?.data?.username,
      phone: profileObject?.data?.phone,
      email: profileObject?.data?.email || 'crm@elsanow.io',
      membership: membershipString,
      lead_source: utm.lead_source,
      Street: profileObject?.data?.address,
      old_package: currentPackages || 'free',
      discount_code: discount_code,
      utm_source: tracking?.utm_source ? tracking.utm_source : utm.utm_source,
      utm_medium: tracking?.utm_medium ? tracking.utm_medium : utm.utm_medium,
      utm_content: utm.utm_content,
      utm_campaign: utm.utm_campaign,
      utm_term: utm.utm_term,
      search: `?placement=${tracking?.placement ? tracking.placement : ''}`,
      'referrer-url': window.location.origin + window.location.pathname,
    };
  
    if(upgradeOption) {
      Object.assign(formdata, upgradeOption);
      const discountCode = getItem(DISCOUNT_CODE) || 'VNTEL';
      formdata.discount_code = discountCode === 'VNKOLUPBF' ?  discountCode + 'VN' : discountCode;
      formdata.search = "?placement=Upgrade&old_package=" + formdata.old_package;
      const utmMedium = membershipString.includes('premium') ? 'Premium-subscribes' : 'Subscribes';
      formdata.utm_medium = formdata.utm_medium === 'Homepage'? utmMedium : formdata.utm_medium || utmMedium;
    }

    if (!isPhoneValid(profileObject?.data?.phone)) {
      message.error('Vui lòng cập nhập số điện thoại hợp lệ');
    } else if (!profileObject?.data?.username) {
      message.error('Vui lòng cập nhập họ và tên hợp lệ');
    } else {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `${config.paymentApiURL}/payment/new-payment`;

      for (const key in formdata) {
        if (formdata.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = formdata[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    }
  };
  return { saveLead };
};

export default useSaveLead;
